/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useParams } from "react-router-dom";

async function roleDelete(token, id) {
  return fetch(process.env.REACT_APP_API_URL + '/crud/roles/' + id,
    {
      method: 'DELETE',
      headers: {
        'Authorization': 'Bearer '+ token,
        'Content-Type': 'application/json'
      },
    })
    .then(data => data.json())
    .catch(function(error) {
      return error;
  });
}

export default function RoleDelete(props) {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const { id } = useParams();

  const handleSubmit = async e => {
    e.preventDefault();
    const response = await roleDelete(props.token, id);
    if (!response || response.error) {
        setError(true);
        return
    }
    setError(false);
    setSuccess(true);
    console.log(response);
  }

  if (props.role !== 1) {   
    return(
      <div className="uk-alert-danger" uk-alert="">
        <p>Unauthorized user access!</p>
      </div>
    );
  }  

  return(
    <div>
      {error ?
        <div className="uk-alert-danger" uk-alert="">
            <p>Role delete error!</p>
        </div>
      : null}
      {success ?
        <div className="uk-alert-success" uk-alert="">
            <a className="uk-alert-close" uk-close=""></a>
            <p>Role deleted successfully</p>
            <a href={'/setup'}>
              <button className="uk-button uk-button-default"><span uk-icon="arrow-left"></span> setup</button>
            </a>
        </div>
      : <div>
          <a href={'../' + id + '/'}>
            <button className="uk-button uk-button-default"><span uk-icon="arrow-left"></span> role</button>
          </a>
          <div className="uk-card uk-card-default uk-margin-top">
            <div className="uk-card-header">
                <h3 className="uk-card-title">Delete Role</h3>
            </div>
            <div className="uk-card-body">
            {id !== '1' ?
            <form className="uk-form-horizontal" uk-grid="" onSubmit={handleSubmit}>
              <p>Are you sure you want to <span className="uk-alert-danger">DELETE</span> the <a href={'../' + id + '/'}>role</a>?</p>
              <div className="uk-width-1-1@s uk-width-1-1@m">
                <button className="uk-button uk-button-default" type="submit">Delete</button>
              </div>
            </form>
            : <p>Can't <span className="uk-alert-danger">DELETE</span> this role</p>}
            </div>
          </div>
        </div>
      }
    </div>
  );
}
